import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { setNetworkStatus } from '../redux/slices/network/netWorkSlice'

export default function NetworkStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine)
    const isOfflineMode = useSelector((state: RootState) => state.offline.isOfflineMode)
    const networkStatus = useSelector((state: RootState) => state.netWork.isOnline)
    const dispatch = useDispatch()

    useEffect(() => {
        // Function to update online status based on browser events
        const handleOnline = () => {
            console.log(isOnline)
            console.log('Browser reports online status')
            setIsOnline(true)
            dispatch(setNetworkStatus(true))
            // Don't automatically exit offline mode - let user decide
        }

        const handleOffline = () => {
            console.log('Browser reports offline status')
            setIsOnline(false)
            dispatch(setNetworkStatus(false))
            // Don't automatically set offline mode - let user decide
        }

        // Initial status check
        if (navigator.onLine) {
            handleOnline()
        } else {
            handleOffline()
        }

        // Listen for browser online/offline events
        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)

        // Cleanup event listeners
        return () => {
            window.removeEventListener('online', handleOnline)
            window.removeEventListener('offline', handleOffline)
        }
    }, [dispatch])

    return (
        <div className="fixed bottom-2 left-4 p-2 rounded-full flex items-center z-50 shadow-md"
            style={{ backgroundColor: networkStatus ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)' }}>
            <div className="flex items-center gap-2 px-3 py-1.5">
                <div className={`w-3 h-3 rounded-full ${networkStatus ? 'bg-green-500' : 'bg-red-500'}`} />
                <span className="text-sm font-medium">
                    {networkStatus ? 'Online' : 'Offline'}
                </span>
                {isOfflineMode && (
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded">
                        Offline Mode
                    </span>
                )}
            </div>
        </div>
    )
} 